import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import { GetAllInterviewSubjects } from '../services/apiservice';
import RandomContent from '../Components/RandomContent';
import Loader from '../Components/Loader';

const InterviewListing = () => {
  const [subjects, setSubjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const fetchSubjects = async () => {
    try {
      const subjectList = await GetAllInterviewSubjects();
      const jsonSubjectList = JSON.parse(subjectList);
      setSubjects(jsonSubjectList);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching interview subjects:', error);
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchSubjects();
  }, []);

  const handleSubjectClick = (subjectSlug) => {
    navigate(`/questions-answers/${subjectSlug}`);
  }

  return (
    <div>


      <Header />

      <RandomContent />

      <div className="blog-area ptb-20">
        <div className="container-block-fluid" style={{ maxWidth: '80%', margin: '0 auto' }}>
          <div className="row" style={{ justifyContent: 'center' }}>
            {loading ? (
              <Loader />
            ) : subjects?.length === 0 ? (
              <div className="col-12 text-center">
                <p>No interview subjects available yet.</p>
              </div>
            ) : (
              subjects?.map((subject) => (

                <div key={subject.id} className="full-col col-lg-2 col-sm-6">
                  <div
                    className="single-counter subject-card"
                    data-aos="fade-up"
                    data-aos-duration="1200"
                    onClick={() => handleSubjectClick(subject.paramlink)}
                  >
                    <h5>
                      <span class="odometer1" data-count="540">{subject.name}</span>
                    </h5>
                    <p>Questions ({subject.questions || 0})</p>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default InterviewListing;
